module.exports = __webpack_public_path__ + "media/images/app/products/earrings_chessboard-be6be413b1ea0161a567f646447cf66d.webp";